import {Modal} from "ui/base/modal/Modal";
import {ButtonPrimary} from "ui/base/Button/ButtonStyled";
import {ExclamationIcon} from "ui/icons";
import styled from "styled-components";
import {themeFontSize} from "ui/theme";
import {Switch} from "ui/base/switch/Switch";
import {useEffect, useState} from "react";
import {changeTeacherListUnList, EnlistStatus} from "api";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {useToast} from "hooks";

export const UnlistModal = ({formData}) => {
    const queryClient = useQueryClient();
    const [isListed, setIsListed] = useState(formData.enlist_status === "active");
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        if (formData.enlist_status) {
            setIsListed(formData.enlist_status === "active");
        }
    }, [formData.enlist_status]);

    const {mutate, isLoading} = useMutation({
        mutationFn: changeTeacherListUnList,
        onError: (err) => {
            useToast(
                "error",
                err?.response?.data?.message || "Error: Change Teacher List Un List"
            );
        },
        onSuccess: () => {
            queryClient.invalidateQueries(["userDetail"]);
        },
    });

    const handleToggle = () => {
        if (!isListed) {
            setIsListed(true);
            mutate(EnlistStatus.LIST);
        } else {
            setIsModalOpen(true);
        }
    };

    const onUnlist = () => {
        setIsListed(false);
        mutate(EnlistStatus.UNLIST);
        setIsModalOpen(false);
    };

    const onClose = () => {
        setIsModalOpen(false);
    };
    return (
        <>
            <ListedContainer>
                <p>{isListed ? "Listed" : "Unlisted"}</p>
                <Switch
                    id="toggle"
                    toggled={isListed}
                    onChange={handleToggle}
                    disabled={isLoading}
                />
            </ListedContainer>
            <Modal
                show={isModalOpen}
                handleClose={onClose}
                minHeight={200}
                maxWidth={450}
            >
                <Container>
                    <div>
                        <ExclamationIcon/>
                    </div>
                    <Message>By unlisting, users won't be able to see your class</Message>
                    <ButtonContainer>
                        <ButtonPrimary onClick={onUnlist}>Unlist</ButtonPrimary>
                        <ButtonPrimary onClick={onClose} variant="outline">
                            Cancel
                        </ButtonPrimary>
                    </ButtonContainer>
                </Container>
            </Modal>
        </>
    );
};

const ListedContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 600;
`;

const Container = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 2rem;
    font-family: Montserrat;
`;

const Message = styled.p`
    font-size: ${themeFontSize("regular")};
    font-weight: 600;
    text-align: center;
`;

const ButtonContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    gap: 2rem;
`;
